export enum awardType {
    BeforeSchool = 1,
    AfterSchool = 2
}
